var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 38,
    viewBox: "0 0 43 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.839355 8C0.839355 3.85786 4.19722 0.5 8.33936 0.5H34.3394C38.4815 0.5 41.8394 3.85786 41.8394 8V30C41.8394 34.1421 38.4815 37.5 34.3394 37.5H8.33935C4.19722 37.5 0.839355 34.1421 0.839355 30V8Z",
    stroke: "#1F2937"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0894 19H16.0969M21.3394 19H21.3469M26.5894 19H26.5969M16.8394 19C16.8394 19.4142 16.5036 19.75 16.0894 19.75C15.6751 19.75 15.3394 19.4142 15.3394 19C15.3394 18.5858 15.6751 18.25 16.0894 18.25C16.5036 18.25 16.8394 18.5858 16.8394 19ZM22.0894 19C22.0894 19.4142 21.7536 19.75 21.3394 19.75C20.9251 19.75 20.5894 19.4142 20.5894 19C20.5894 18.5858 20.9251 18.25 21.3394 18.25C21.7536 18.25 22.0894 18.5858 22.0894 19ZM27.3394 19C27.3394 19.4142 27.0036 19.75 26.5894 19.75C26.1751 19.75 25.8394 19.4142 25.8394 19C25.8394 18.5858 26.1751 18.25 26.5894 18.25C27.0036 18.25 27.3394 18.5858 27.3394 19Z",
    stroke: "#111827",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.73c85e32f0921f040869ebcbac46b011.svg";
export { ForwardRef as ReactComponent };